/* CYME CUSTOM: product-gallery zoom prewarm.
   Kept in a product-only asset so PDPs do not download the homepage marquee
   runtime merely to initialize PhotoSwipe before the first interaction. */
(() => {
  const warmed = new WeakSet();

  const galleriesWithin = (root) => {
    const galleries = [];

    if (root instanceof Element && root.matches('product-gallery[allow-zoom]')) {
      galleries.push(root);
    }

    root.querySelectorAll?.('product-gallery[allow-zoom]').forEach((gallery) => galleries.push(gallery));
    return galleries;
  };

  const prewarm = async (root = document) => {
    // `theme.js` is a module while this small page-specific asset is deferred.
    // Wait for Prestige to upgrade the custom element instead of relying on
    // their relative network timing.
    await window.customElements.whenDefined('product-gallery');

    galleriesWithin(root).forEach((gallery) => {
      if (warmed.has(gallery)) {
        return;
      }

      try {
        // Touching the getter creates and initializes Prestige's lightbox
        // controller. The PhotoSwipe module remains lazy and loads on demand.
        void gallery.lightBox;
        warmed.add(gallery);
        gallery.dataset.cymeZoomPrewarm = 'ready';
      } catch {
        // Non-fatal: Prestige retains its native lazy initialization path.
        gallery.dataset.cymeZoomPrewarm = 'failed';
      }
    });
  };

  const schedule = (root = document) => {
    if ('requestIdleCallback' in window) {
      requestIdleCallback(() => prewarm(root), { timeout: 4000 });
    } else {
      setTimeout(() => prewarm(root), 1500);
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule, { once: true });
  } else {
    schedule();
  }

  document.addEventListener('shopify:section:load', (event) => schedule(event.target));
})();
